import * as React from 'react';

import { DeviceAlertsSettings } from './deviceAlertsSettings';
import { BatteryAlertsSettings } from './batteryAlertsSettings';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export enum BatterySettingsLicense {
  none = "none",
  onlyBattery = "onlyBattery",
  onlyDevices = "onlyDevices",
  batteryAndDevices = "batteryAndDevices"
}

export interface IProps {
  worldSettings: WorldSettings,
  licensed: BatterySettingsLicense,
  onDataChanged: (data: WorldSettings) => void,
  submitInProgress: boolean,
  dataTimestamp: number,
  initialWorldSettings: WorldSettings
}

export function BatterySettings(props: IProps) {

  const settings = [
    <BatteryAlertsSettings key='battery-alerts' dataTimestamp={props.dataTimestamp} onDataChanged={props.onDataChanged} worldSettings={props.worldSettings} submitInProgress={props.submitInProgress}/>,
    <DeviceAlertsSettings key='device-alerts' dataTimestamp={props.dataTimestamp} onDataChanged={props.onDataChanged} worldSettings={props.worldSettings} submitInProgress={props.submitInProgress} />
  ];

  if (props.licensed === BatterySettingsLicense.onlyBattery) {
    settings.splice(-1, 1);
  } else if (props.licensed === BatterySettingsLicense.onlyDevices) {
    settings.splice(0, 1);
  }

  return <div className="battery threshold-settings-composition">
    {settings}
  </div>;
}
